module.exports = __webpack_public_path__ + "img/UserCircle.e91be4c9.svg";